import { useState } from "react"
import { Form, FormGroup, Label, Input, Button } from "reactstrap"
import Utils from "../Utils"

const DEFAULT_FORM_STATE = {
    titulo: "",
    texto: ""
}

const FormNotificar = ({ idUsuario }) => {

    const [form, setForm] = useState(DEFAULT_FORM_STATE)

    const handleInputChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value
        })
    }

    const notificarUsuario = async () => {
        try {
            await Utils.API.NotificarUsuario(idUsuario, form.titulo, form.texto)
            // reset
            setForm(DEFAULT_FORM_STATE)
            alert("Notificación enviada!")
        } catch(err) {
            Utils.AlertError(err, `No se pudo notificar al usuario`)
        }
    }

    const notificarTodos = async () => {
        try {
            await Utils.API.NotificarTodos(form.titulo, form.texto)
            // reset
            setForm(DEFAULT_FORM_STATE)
            alert("Notificación enviada!")
        } catch(err) {
            Utils.AlertError(err, `No se pudo notificar al usuario`)
        }
    }

    const onSubmit = event => {
        event.preventDefault()
        if(idUsuario) {
            notificarUsuario()
        } else {
            notificarTodos()
        }
    }

    const isValidForm = (form.texto.length > 0 && form.titulo.length > 0)

    return(
        <Form onSubmit={onSubmit}>
            <FormGroup>
                <Label>Titulo</Label>
                <Input onChange={handleInputChange} name="titulo" value={form.titulo} />
            </FormGroup>
            <FormGroup>
                <Label>Texto de la notificación</Label>
                <Input onChange={handleInputChange} name="texto" value={form.texto} type="textarea" />
            </FormGroup>
            <Button disabled={!isValidForm} color="success" size="lg" block>Notificar</Button>
        </Form>
    )
}

export default FormNotificar